module.exports = __webpack_public_path__ + "static/media/ic_table_feature.1158525f.svg";